import UAParser from 'ua-parser-js';

var vsPrimaryDomains = ['hamrick.com', 'vuescan.com'];
var vsUrlParserAnchor = document.createElement('a');

var vsStringEndsWith = function (str, suffix) {
  return str.length >= suffix.length && str.indexOf(suffix, str.length - suffix.length) !== -1;
};

var vsGetPrimaryDomain = function (hostname) {
  if (!hostname) {
    return '';
  }
  var lowerHost = hostname.toLowerCase();
  for (var i = 0; i < vsPrimaryDomains.length; i++) {
    var domain = vsPrimaryDomains[i];
    if (lowerHost === domain || vsStringEndsWith(lowerHost, '.' + domain)) {
      return domain;
    }
  }
  return '';
};

var vsTrimTrailingSlash = function (value) {
  return value ? value.replace(/\/+$/, '') : '';
};

var vsParseUrl = function (url) {
  if (!url) {
    return null;
  }
  vsUrlParserAnchor.href = url;
  return {
    hostname: vsUrlParserAnchor.hostname || '',
    pathname: vsUrlParserAnchor.pathname || '',
    search: vsUrlParserAnchor.search || ''
  };
};

var vsGetCurrentOrigin = function () {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }
  if (window.location.origin) {
    return window.location.origin;
  }
  return window.location.protocol + '//' + window.location.host;
};

var vsNormalizeVsvarsForHost = function () {
  if (typeof window === 'undefined' || !window.location) {
    return;
  }

  window.vsvars = window.vsvars || {};

  var currentDomain = vsGetPrimaryDomain(window.location.hostname || '');
  if (!currentDomain) {
    return;
  }

  var origin = vsTrimTrailingSlash(vsGetCurrentOrigin());
  if (!origin) {
    return;
  }

  var baseInfo = vsParseUrl(window.vsvars.baseurl);
  var baseDomain = baseInfo ? vsGetPrimaryDomain(baseInfo.hostname) : '';
  if (!window.vsvars.baseurl || (baseDomain && baseDomain !== currentDomain)) {
    window.vsvars.baseurl = origin;
  } else if (baseInfo && !baseDomain && vsTrimTrailingSlash(window.vsvars.baseurl) !== origin) {
    window.vsvars.baseurl = origin;
  }

  var backendInfo = vsParseUrl(window.vsvars.backendurl);
  var backendPath = '/a';
  if (backendInfo) {
    var path = backendInfo.pathname || '';
    if (!path || path === '/') {
      path = '/a';
    }
    if (path.charAt(0) !== '/') {
      path = '/' + path;
    }
    var search = backendInfo.search || '';
    backendPath = path + search;
  }
  window.vsvars.backendurl = window.vsvars.baseurl + backendPath;
};

vsNormalizeVsvarsForHost();

var vsSiteAffiliation = 'hamrick.com';
if (typeof window !== 'undefined' && window.location) {
  var vsCurrentDomain = vsGetPrimaryDomain(window.location.hostname || '');
  if (vsCurrentDomain) {
    vsSiteAffiliation = vsCurrentDomain;
  }
}

// This function will cause the canonical url to be used instead of the actual url.
// This is useful during a/b tests so we don't split the analytics data across both urls
// This will fall back to the url if there is no canonical url present
window.vsGetCanonicalUrl = function () {
  var url;
  if (document.querySelector) {
    var canonicalLink = document.querySelector('link[rel=canonical]');
    if (canonicalLink && canonicalLink.getAttribute) {
      url = canonicalLink.getAttribute('href');
    }
  } else {
    var links = document.getElementsByTagName("link");

    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute("rel") === "canonical") {
        url = links[i].getAttribute("href")
      }
    }
  }

  if (!url) {
    url = window.location.href;
    // Remove query string from fallback URL
    if (url.indexOf('?') !== -1) {
      url = url.split('?')[0];
    }
  }

  if (url) {
    url = url.replace('http://', '');
    url = url.replace('https://', '');
    url = url.replace('www.', '');
    for (var i = 0; i < vsPrimaryDomains.length; i++) {
      url = url.replace(vsPrimaryDomains[i], '');
    }
    url = url.replace('localhost', '');
    if (!url) {
      url = '/';
    }
  }

  return url;
}

window.vsIsLocal = function () {
  return (location.hostname === "localhost" || location.hostname === "127.0.0.1");
}

window.vsGetCookie = function (sName) {
  sName = sName.toLowerCase();
  var oCrumbles = document.cookie.split(';');
  for (var i = 0; i < oCrumbles.length; i++) {
    var oPair = oCrumbles[i].split('=');
    var sKey = decodeURIComponent(oPair[0].trim().toLowerCase());
    var sValue = oPair.length > 1 ? oPair[1] : '';
    if (sKey == sName)
      return decodeURIComponent(sValue);
  }
  return '';
}
window.vsSetCookie = function (sName, sValue) {
  var oDate = new Date();
  oDate.setYear(oDate.getFullYear() + 1);
  var hostname = window.location.hostname;
  var domainAttr = '';
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    var cookieDomain = vsGetPrimaryDomain(hostname);
    if (cookieDomain) {
      domainAttr = ';domain=.' + cookieDomain;
    }
  }
  var sCookie = encodeURIComponent(sName) + '=' + encodeURIComponent(sValue) + ';expires=' + oDate.toGMTString() + ';path=/' + domainAttr;
  document.cookie = sCookie;
};
var vsClearCookie = function (sName) {
  window.vsSetCookie(sName, '');
};

window.vsGetLanguageSubdirectory = function () {
  language = 'en';
  pathComps = window.location.pathname.split('/');
  if (pathComps.length >= 1 && pathComps[1].length == 2) {
    language = pathComps[1];
  }
  return language;
};

var vsDownloadFile = function (url, callback) {
  callback = callback || function () {};
  var hiddenIFrameID = 'hidden-iframe';
  var iframe = document.getElementById(hiddenIFrameID);
  if (iframe === null) {
    iframe = document.createElement('iframe');
    iframe.onload = callback;
    iframe.id = hiddenIFrameID;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
  }
  iframe.src = url;
}

var vsReady = function (callback) {
  if (document.readyState != "loading")
    callback();
  else
    document.addEventListener("DOMContentLoaded", callback);
}

var vsGetQueryParamsFromUrl = function (href) {
  var paramDict = {};
  // Get rid of the url and split each param in to a list
  var querystring = href;
  if (querystring.indexOf('?') != -1) {
    var paramList = querystring.split('#')[0].substring(querystring.indexOf('?') + 1).split('&');

    // Parse params from query string
    for (var i = paramList.length - 1; i >= 0; i--) {
      var pair = paramList[i].split('=');
      paramDict[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
  }
  return paramDict;
}

var vsGetQueryParams = function () {
  var paramDict = window.vsQueryParamDict || {};
  // Use the new function with window.location.href
  return Object.assign(paramDict, vsGetQueryParamsFromUrl(window.location.href));
}
window.vsGetQueryParams = vsGetQueryParams;
window.vsGetQueryParamsFromUrl = vsGetQueryParamsFromUrl;

var vsHideQueryParams = function () {
  // Store the current query params in the window object to be able to access later
  window.vsQueryParamDict = vsGetQueryParams();
  // Remove query string from URL
  if (window.history && window.history.pushState) {
    window.history.pushState({}, document.title, window.location.href.substring(0, window.location .href.indexOf('?')));
  }
}

var vsGetQueryString = function () {
  params = vsGetQueryParams();
  queryString = vsToQueryString(params);
  if (queryString.length > 0) {
    queryString = "?" + queryString;
  }
  return queryString;
}

// From http://stackoverflow.com/questions/5505085/flatten-a-javascript-object-to-pass-as-querystring
window.vsToQueryString = function (obj) {
  var parts = [];
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
      // parts.push(i + "=" + obj[i]);
    }
  }
  return parts.join("&");
}

var vsJSONP = function (href, callback, object) {
  if(href.indexOf('?') == -1) {
    href += "?";
  }
  if (callback) {
    href += "callback=" + callback + "&"
  }
  if (object) {
    href += vsToQueryString(object);
  }
  var script_element = document.createElement('script');
  script_element.src = href;
  script_element.setAttribute('type', 'text/javascript');
  script_element.defer = true;
  script_element.async = true;
  document.getElementsByTagName('head')[0].appendChild(script_element);
};
window.vsJSONP = vsJSONP;

window.vsGetUserAgent = function (callback) {
  var uaparser = new UAParser(navigator.userAgent);
  userAgentResults = uaparser.getResult()
  var internalCallback = function () {
    window.vsUserAgent = userAgentResults;
    if (callback)
        callback(userAgentResults)
  }
  if (navigator.userAgentData && navigator.userAgentData.getHighEntropyValues) {
      navigator.userAgentData.getHighEntropyValues(["platformVersion", "architecture", "bitness"]).then(function (highEntropy) {
          userAgentResults.highEntropy = highEntropy
          // if (he.architecture) {
          //     userAgentResults.cpu.architecture = he.architecture
          // }
          // if (he.bitness) {
          //     userAgentResults.cpu.bitness = he.bitness
          // }
          // if (he.platformVersion) {
          //     userAgentResults.os.version = he.platformVersion;
          // }
      }).catch(function(err) {
          console.error(err);
      }).finally(internalCallback);
  } else {
      internalCallback()
  }
}

function vsPricingQuote() {
  var el = document.getElementById('pricing-experiment-quote');
  return el ? JSON.parse(el.textContent) : null;
}

function vsPricingPaypalCreate(el, subscription) {
  var quote = vsPricingQuote();
  if (!quote) return null;
  var sku = Object.keys(quote.offers).find(function (code) {
    var offer = quote.offers[code];
    return subscription ? offer.plan && offer.plan === el.dataset.paypalSubscriptionPlan
      : offer.name === el.dataset.paypalSku && !code.endsWith('-A') && !code.endsWith('-S') && !code.endsWith('-U');
  });
  if (!sku) return Promise.reject(new Error('Offer changed. Reload the purchase page.'));
  return fetch(window.vsvars.backendurl + '/api/pricing-paypal-checkout', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ quote: quote.token, sku: sku, subscription: subscription,
      amount: el.dataset.paypalPrice, currency: el.dataset.paypalCurrency })
  }).then(function (response) {
    if (!response.ok) throw new Error('Unable to start checkout. Reload the purchase page.');
    return response.json();
  }).then(function (result) { return result.id; });
}

var vsClickStripe = function (event) {
  event.preventDefault();
  var stripeCheckoutElement = this;
  var testFlag = (vsGetQueryParams()['test'] == '1') ? 1 : 0;
  
  // Check if this is a subscription upgrade button
  var subscription_id = stripeCheckoutElement.dataset.subscriptionId;
  
  // New method: data-stripe-price and data-stripe-currency
  var stripe_price = stripeCheckoutElement.dataset.stripePrice;
  var stripe_currency = stripeCheckoutElement.dataset.stripeCurrency;
  var stripe_edition = stripeCheckoutElement.dataset.stripeEdition; // 'BAS', 'STD', 'PRO', 'STD-S', 'PRO-A', etc.
  
  var discount = testFlag ? stripeCheckoutElement.dataset.testDiscount : stripeCheckoutElement.dataset.discount;
  
  if (testFlag || location.protocol == 'https:') {
    stripeCheckoutElement.querySelectorAll(".vs-cc-spinner").forEach(function (el) {
      el.classList.remove('hidden')
    });
    
    payload = {
      test: testFlag,
    };
    var pricingQuote = vsPricingQuote();
    if (pricingQuote) payload.pricing_quote = pricingQuote.token;
    
    // Determine which method to use
    if (subscription_id && stripe_edition) {
      // Subscription upgrade method: send subscription ID and target edition
      payload.subscription_id = subscription_id;
      payload.target_edition = stripe_edition;
    } else if (stripe_price && stripe_currency) {
      // New method: send amount and currency
      payload.amount = stripe_price;
      payload.currency = stripe_currency;
      if (stripe_edition) {
        payload.edition = stripe_edition;
      }
    } else {
      alert("Payment configuration error - please contact support");
      return;
    }
    
    queryParams = vsGetQueryParams();
    if (queryParams.country) {
      payload.country = queryParams.country
    }
    if (discount && discount.length > 0) {
      payload.discount = discount;
    }
    if (queryParams.link === '0') {
      payload.link = '0';
    }
    
    // Add current page URL as back_url for dynamic Stripe cancel redirect
    payload.back_url = window.location.href;
    
    fetch(window.vsvars.backendurl + "/api/stripe-session-token?"+vsToQueryString(payload)).then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to create checkout session");
      }
      return response.json()
    }).then(function (stripeToken) {
      if (!stripeToken.url) {
        throw new Error("Checkout session has no URL");
      }
      window.location.assign(stripeToken.url);
    }).catch(function () {
      alert("Unable to start checkout. Please try again or contact support.");
    }).finally(function () {
      stripeCheckoutElement.querySelectorAll(".vs-cc-spinner").forEach(function (el) {
        el.classList.add('hidden')
      });
    });
  } else {
    alert("Checkout Error - Make sure you use test mode")
  }
}

window.vsSearchFormSubmit = function () {
    statObj = vsGetStatObj();
    statObj.UserSearch = document.querySelector("form [name='q']").value;
    if (!vsIsLocal()) {
        vsJSONP("https://stats.hamrick.com/v1/stat", null, statObj);
    }
    return true;
}

// PayPal SDK loading and button helpers
// Uses data-namespace to load two SDK instances when both one-time and
// subscription buttons coexist on the same page.

var vsPaypalClientId = (vsGetQueryParams().test == '1')
  ? "AdnIToD3VDSJdXGWAlSOy2swlP3DsXKNtQnZ1nl9g8aCPumNM5NhfzY2MHvxabjRU0afTFMcOKbw8s5D"
  : "AQ3XEQQDcepREnz7CiC6AqHLDX5EwuBGu-FskfdU4NgRIxzq5RXLXuRnEfiCnVgTviPz1Qh5wpGgLqBg";

var vsPaypalStyle = { shape: 'pill', color: 'silver', layout: 'vertical', label: 'paypal' };

function vsPaypalInjectSDK(currency_code, options, callback) {
  if (['INR','ZAR','KRW','CNY'].indexOf(currency_code) != -1) return;

  var url = "https://www.paypal.com/sdk/js?currency=" + currency_code
    + "&client-id=" + vsPaypalClientId;
  if (options.vault) url += "&vault=true";
  if (options.intent) url += "&intent=" + options.intent;
  var js_script = document.createElement('script');
  js_script.type = "text/javascript";
  js_script.src = url;
  if (options.namespace) js_script.setAttribute('data-namespace', options.namespace);
  js_script.defer = true;
  js_script.async = true;
  if (callback) js_script.onload = callback;
  document.getElementsByTagName('head')[0].appendChild(js_script);
}

// One-time order completion
var vsPaypalPostComplete = function (details) {
  fetch(window.vsvars.backendurl + "/api/paypal-clientside", {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(details)
  }).then(function (response) {
    return response.json();
  }).then(function (response) {
    if (response.redirect_url) {
      document.location = response.redirect_url;
    }
  });
}

function vsPaypalRenderOnetimeButtons(sdk, elements) {
  elements.forEach(function (el) {
    sdk.Buttons({
      style: vsPaypalStyle,
      fundingSource: sdk.FUNDING.PAYPAL,
      createOrder: function(data, actions) {
        var quotedOrder = vsPricingPaypalCreate(el, false);
        if (quotedOrder) return quotedOrder;
        return actions.order.create({
          purchase_units: [{
            description: el.dataset.paypalSku,
            amount: { value: el.dataset.paypalPrice }
          }]
        });
      },
      onApprove: function(data, actions) {
        return actions.order.capture().then(vsPaypalPostComplete);
      }
    }).render('#' + el.id);
  });
}

function vsPaypalRenderSubscriptionButtons(sdk, elements) {
  elements.forEach(function (el) {
    sdk.Buttons({
      style: vsPaypalStyle,
      fundingSource: sdk.FUNDING.PAYPAL,
      createSubscription: function(data, actions) {
        var quotedSubscription = vsPricingPaypalCreate(el, true);
        if (quotedSubscription) return quotedSubscription;
        return actions.subscription.create({ plan_id: el.dataset.paypalSubscriptionPlan });
      },
      onApprove: function(data, actions) {
        return vsPaypalSubscriptionPostComplete(data);
      },
      onError: function(err) {
        console.error('PayPal subscription button error:', err);
      }
    }).render('#' + el.id);
  });
}

window.vsPaypalLoadButtons = function () {
  var subscriptionElements = document.querySelectorAll('[data-paypal-subscription-plan]');
  var onetimeElements = document.querySelectorAll('[data-paypal-currency]:not([data-paypal-subscription-plan])');
  var hasSubs = subscriptionElements.length > 0;
  var hasOnetime = onetimeElements.length > 0;

  if (hasSubs && hasOnetime) {
    // Both on same page: load two SDK instances with different namespaces
    var currency = onetimeElements[0].dataset.paypalCurrency;
    var loaded = 0;
    var onBothLoaded = function () {
      loaded++;
      if (loaded < 2) return;
      vsPaypalRenderOnetimeButtons(window.paypal, onetimeElements);
      vsPaypalRenderSubscriptionButtons(window.paypalSubscription, subscriptionElements);
    };
    vsPaypalInjectSDK(currency, {}, onBothLoaded);
    vsPaypalInjectSDK('EUR', { vault: true, intent: 'subscription', namespace: 'paypalSubscription' }, onBothLoaded);
  } else if (hasSubs) {
    var currency = subscriptionElements[0].dataset.paypalCurrency || 'EUR';
    vsPaypalInjectSDK(currency, { vault: true, intent: 'subscription' }, function () {
      vsPaypalRenderSubscriptionButtons(window.paypal, subscriptionElements);
    });
  } else if (hasOnetime) {
    var currency = onetimeElements[0].dataset.paypalCurrency;
    vsPaypalInjectSDK(currency, {}, function () {
      vsPaypalRenderOnetimeButtons(window.paypal, onetimeElements);
    });
  }
}

// Keep these as aliases for alpine-components.js compatibility
window.vsPaypalLoadSDK = function (currency_code, options, callback) {
  vsPaypalInjectSDK(currency_code, options || {}, callback);
}
window.vsPaypalLoadButton = function (description, price, selector) {
  paypal.Buttons({
    style: vsPaypalStyle,
    fundingSource: paypal.FUNDING.PAYPAL,
    createOrder: function(data, actions) {
      return actions.order.create({
        purchase_units: [{ description: description, amount: { value: price } }]
      });
    },
    onApprove: function(data, actions) {
      return actions.order.capture().then(vsPaypalPostComplete);
    }
  }).render(selector);
}

var vsPaypalSubscriptionPostComplete = function (data) {
  var buttons = document.querySelectorAll('[data-paypal-subscription-plan]');
  buttons.forEach(function(btn) {
    btn.innerHTML = '<p style="text-align:center;">Processing...</p>';
  });

  fetch(window.vsvars.backendurl + "/api/paypal-subscription-clientside", {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      subscriptionID: data.subscriptionID,
      test_mode: vsGetQueryParams().test == '1'
    })
  }).then(function (response) {
    return response.json();
  }).then(function (response) {
    if (response.redirect_url) {
      document.location = response.redirect_url;
    } else if (!response.success) {
      alert('There was an error processing your subscription. Please try again or contact support.');
    }
  }).catch(function(error) {
    console.error('PayPal subscription error:', error);
    alert('There was an error processing your subscription. Please try again or contact support.');
  });
}

var vsUpdateDOMElements = function () {
  scannerCompatibilityArgs = window.vsScannerCompatibilityArgs || [32, 64, 64, 64, 32, 32, 64, 1, 0];
  scannerInfo = vsSetScannerInfo.apply(null, scannerCompatibilityArgs);
  
  queryParams = vsGetQueryParams();
  
  var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
  var is_safari = navigator.userAgent.indexOf("Safari") > -1;
  var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
  if ((is_chrome) && (is_safari)) {
    is_safari = false;
  }
  if ((is_chrome) && (is_opera)) {
    is_chrome = false;
  }
  var isApple = !!navigator.userAgent.match(/(Mac|iPhone|iPod|iPad)/i);
  var isWindows = !!navigator.userAgent.match(/(Win32|Win64|Windows|WinCE)/);
  // ChromeOS reports "X11; CrOS ..." with no "Linux" token - treat it as Linux,
  // matching what vsSetScannerInfo() does with its X11 check
  var isLinux = !isApple && !isWindows && !!/(Linux|X11|CrOS)/.test(navigator.userAgent);
  var isMobile = !!scannerInfo && scannerInfo.osString == 'Mobile';
  var shouldUseModal = !!window.vsPageInfo || vsGetCanonicalUrl().indexOf('/vuescan/') !== -1;
  if (vsGetQueryParams().os == 'macos') {
    isApple = true;
    isWindows = false;
    isLinux = false;
  } else if (vsGetQueryParams().os == 'windows') {
    isWindows = true;
    isApple = false;
    isLinux = false;
  } else if (vsGetQueryParams().os == 'linux') {
    isLinux = true;
    isApple = false;
    isWindows = false;
  }

  var showClass = null;
  if (isApple) {
    showClass = '.vs-show-macos';
  } else if (isWindows) {
    showClass = '.vs-show-windows';
  } else if (isLinux) {
    showClass = '.vs-show-linux';
  }
  if (showClass) {
    document.querySelectorAll(showClass).forEach(function (el) {
      el.classList.remove('hidden');
    });

    document.querySelectorAll(showClass+' img').forEach(function (el) {
      if(!el.src && el.dataset.src) {
        el.src = el.dataset.src;
      }
    });
  }

  document.querySelectorAll('.vsVersionNumber').forEach(function (el) {
    el.innerHTML = scannerInfo.ve;
  });

  document.querySelectorAll('.vsReleaseDate').forEach(function (el) {
    el.innerHTML = scannerInfo.up;
  });

  document.querySelectorAll('.vs-mac-windows-img').forEach(function (el) {
    var src = isApple ? el.dataset.macUrl : el.dataset.winUrl;
    if (src)
      el.src = src;

    if (el.parentElement.tagName == 'PICTURE') {
      el.parentElement.querySelectorAll('source').forEach(function (sourceEl) {
        var srcset = isApple ? sourceEl.dataset.macSrcset : sourceEl.dataset.winSrcset;
        if (srcset)
          sourceEl.srcset = srcset;
      });
    }
  });
 
  var vsMouseListener = function () {
    document.querySelectorAll('video').forEach(function (el) {
      el.play();
    });
    document.body.removeEventListener("mousemove", vsMouseListener, false);
  }
  setTimeout(function () {
    document.body.addEventListener("mousemove", vsMouseListener, false);
  }, 100); 


  var h1el = document.querySelector("h1");
  if (h1el) {
    var vendorName = h1el.dataset.vendorName;
    var h2 = document.querySelector("h2");
    if (h2) {
      var h2html = h2.innerHTML;
      h2html = h2html.replace(vendorName, "<span class=\"text-royal-blue-500 text-4xl sm:text-6xl text-nowrap\">" + vendorName + "</span>")
      document.querySelector("h2").innerHTML = h2html;
    }
  }

  if (queryParams['d'] == '1') {
    document.querySelectorAll('.vuescan-version-download').forEach(function (el) {
      el.classList.remove('hidden');
    });
  }

  if (!!scannerInfo && scannerInfo.oc) {

    // Display 64-bit message
    if (scannerInfo.fn && !!scannerInfo.fn.match("32")) {
      document.querySelectorAll(".vs-32bit-only").forEach(function (el) {
        el.classList.remove("hidden");
      });
    }

    // Download File

    if (scannerInfo.downloadPageUrl || scannerInfo.fn) {
      document.querySelectorAll(".vsDownloadButton").forEach(function (el) {
        el.href =  scannerInfo.downloadPageUrl || scannerInfo.fn;
      });
      document.querySelectorAll(".vsDownloadLink").forEach(function (el) {
        el.href = scannerInfo.fn;
      });
      document.querySelectorAll(".vsDownloadText").forEach(function (el) {
        el.innerHTML = "VueScan " + scannerInfo.ve + ". " + scannerInfo.up + ". " + scannerInfo.os;
      });
      if (scannerInfo.fn) {
        var fullPathString = scannerInfo.fn;
        fullPathString = fullPathString.substring(fullPathString.lastIndexOf('/') + 1);
        document.querySelectorAll(".vsDownloadFileName").forEach(function (el) {
          el.innerHTML = fullPathString
        });
      }
    } else {
      document.querySelectorAll(".vsDownloadButton").forEach(function (el) {
        el.classList.add('hidden');
      });
      document.querySelectorAll(".vsDownloadText").forEach(function (el) {
        el.classList.add('hidden');
      });
    }
  } else {
    document.querySelectorAll(".vsDownloadButton").forEach(function (el) {
      el.classList.add('hidden');
    });
  }
  if (!!vsGetCanonicalUrl().match("download")) {
    if (queryParams.v || queryParams.dl == '1') {
        vsDownloadFile(scannerInfo.fn);
    }
  }

  if (isMobile) {
    // Change the text of the mobile button
    document.querySelectorAll("a[type='button'].vsDownloadButton span").forEach(function (el) {
      if (!el.classList.contains('navbar-btn')) {
        el.innerHTML = "Email link to download VueScan";
      }
    });
  } else if (!!scannerInfo && scannerInfo.osString) {
    document.querySelectorAll('.vsPlatform').forEach(function (el) {
      el.innerHTML = scannerInfo.osString;
    });
  }
  var downloadClick = function(event) {
    event.preventDefault();
    isMobile = scannerInfo.osString == 'Mobile';
    statObj = vsGetStatObj()
    localStorage.setItem("vsDownloadPageStatObj", JSON.stringify(statObj));
    hasLeadID = !!localStorage.getItem("vsLeadID")
    var CanonicalURL = statObj['CanonicalURL'];

    // Email required only on mobile (desktop email gate A/B test ended 2026-03-13)
    var requireEmail = isMobile && !hasLeadID;

    if (requireEmail && window.Alpine) {
      document.location = window.vsvars.baseurl + '/email-download.html';
    } else {
      redirectURL = window.scannerInfo.downloadPageUrl;
      if (is_safari) {
        window.location = redirectURL;
      } else {
        openDownloadReturnStatus = window.open(redirectURL,"_blank");
        if(!openDownloadReturnStatus) {
          setTimeout(function () {
            window.location = redirectURL;
          }, 2000);
        }
      }
    }
  }
  document.querySelectorAll(".vsDownloadButton").forEach(function (el) {
    el.addEventListener("click", downloadClick);
  });

  document.querySelectorAll(".vs-payment-stripe").forEach(function (el) {
    el.addEventListener("click", vsClickStripe);
  });

  if (window.vsPageInfo) {
    var scannerCapabilities = 0;
    scannerCapabilities |= window.vsPageInfo.hasFlatbed ? 1 << 0 : 0;
    scannerCapabilities |= window.vsPageInfo.hasADF ? 1 << 1 : 0;
    scannerCapabilities |= window.vsPageInfo.hasFilm ? 1 << 2 : 0;
    scannerCapabilities |= window.vsPageInfo.needsPlugin ? 1 << 3 : 0;
    scannerCapabilities |= window.vsPageInfo.oldWin ? 1 << 4 : 0;
    scannerCapabilities |= window.vsPageInfo.oldMac ? 1 << 5 : 0;
    if (!!scannerInfo) {
      scannerCapabilities |= window.scannerInfo.mfp ? 1 << 6 : 0;
    }
    var capabilitiesString = window.vsPageInfo.scannerVendor + ";" + window.vsPageInfo.scannerName + ";" + scannerCapabilities;
    window.vsSetCookie("vsScannerPage", capabilitiesString);

    var scannerType = 0
    scannerType |= window.vsPageInfo.hasFlatbed ? 1 << 0 : 0;
    scannerType |= window.vsPageInfo.hasADF ? 1 << 1 : 0;
    scannerType |= window.vsPageInfo.hasFilm ? 1 << 2 : 0;
    if (scannerType != 0) {
      localStorage.setItem("vsScannerType",scannerType);
    }
    localStorage.setItem("vsScannerVendor",window.vsPageInfo.scannerVendor);
    localStorage.setItem("vsScannerModel",window.vsPageInfo.scannerName);
  }
  // localStorage.setItem("vsLanguageSubdirectory",vsGetLanguageSubdirectory());

  // Extract Scanner Info from Query Params if they are present (ie. on buy1 -> reg.html?Vendor=xxx etc.)
  if(queryParams.Type) {
    localStorage.setItem("vsScannerType",queryParams.Type)
    localStorage.setItem("FeedbackData", JSON.stringify(queryParams));
  }
  if(queryParams.Vendor) {
    localStorage.setItem("vsScannerVendor",queryParams.Vendor)
  }
  if(queryParams.Model) {
    localStorage.setItem("vsScannerModel",queryParams.Model)
  }
  if (queryParams.Type && queryParams.Vendor && queryParams.Model) {
    console.log("setting vsScannerPage", queryParams.Vendor + ";" + queryParams.Model + ";" + queryParams.Type);
    localStorage.setItem("vsScannerPage",queryParams.Vendor + ";" + queryParams.Model + ";" + queryParams.Type);
    window.vsSetCookie("vsScannerPage", queryParams.Vendor + ";" + queryParams.Model + ";" + queryParams.Type);
  }

  // First launch time
  if (!localStorage.getItem("vsFirstVisitTime")) {
    localStorage.setItem("vsFirstVisitTime",(new Date()).toISOString());
  }
  if (!localStorage.getItem("vsFirstRegTime") && !!vsGetCanonicalUrl().match("/purchase-vuescan.html")) {
    localStorage.setItem("vsFirstRegTime",(new Date()).toISOString());
  }

  // Track landing page for discount A/B test
  var currentPath = vsGetCanonicalUrl();
  if (!vsGetCookie('vsLandingPage')) {
    // Set cookie to track the user's landing page
    window.vsSetCookie('vsLandingPage', currentPath);
  }

  // Feedback page
  if (!!vsGetCanonicalUrl().match("feedback.html")) {
    // Send GET request to server with query string params
    if (!vsIsLocal()) {
        vsJSONP(window.vsvars.backendurl + "/feedback-visit" + vsGetQueryString());
    }

    // Store query params
    queryParams = vsGetQueryParams();
    localStorage.setItem("FeedbackData", JSON.stringify(queryParams));
    var vendor = (queryParams.Vendor || "");
    if (vendor != "Generic" && vendor != "Video") {
      var capabilitiesString = queryParams.Vendor + ";" + queryParams.Model + ";" + queryParams.Type;
      window.vsSetCookie("vsScannerPage", capabilitiesString);
    }

    // Check if there was no scanner found and change the titles
    if ((queryParams.Vendor || "") == "Generic" || (queryParams.Vendor || "") == "Video") {
      var el = document.querySelector(".vs-fg-problem-no-scanner");
      if (el) el.classList.remove('hidden');

      var el = document.querySelector(".report-page-container");
      if (el) el.classList.add('hidden');
    } else {
        window.location = window.vsvars.baseurl + "/purchase-vuescan.html"
    }

    vsHideQueryParams();
  }
  
  // PayPal subscription buttons on Purchase pages
  vsPaypalLoadButtons();

  // In-app pages (/inapp/…) are shown in VueScan's embedded browser. Leave a
  // marker so the invoice page - which we land on after checkout, in the same
  // webview - knows it can hand the registration back to VueScan without a
  // click. In a regular browser vuescan:// pops an "Open VueScan?" dialog, so
  // registration stays button-only there.
  if (window.location.pathname.toLowerCase().indexOf('/inapp/') != -1) {
    try {
      window.localStorage.setItem('vsInAppPurchase', String(Date.now()));
    } catch (e) {
      // Storage blocked (private/ephemeral webview) - fall back to click-only
    }
  }

  // Download page
  if (!!vsGetCanonicalUrl().match("/download.html")) {
    // Track download page reach as conversion for A/B tests
    vsTrackDownloadConversion();
    
    if (isMobile) {
      window.location = window.vsvars.baseurl + '/alternate-versions.html';
    }
  }

  var isPurchasePage = !!vsGetCanonicalUrl().match("/purchase-vuescan.html");

  // A customer may return near a renewal and otherwise be enrolled in a fresh
  // countdown sale. Check browser-known invoices on every site page so the
  // server-side purchase page usually receives the answer on its first render.
  // Only reload when someone arrived directly on a purchase page with stale
  // eligibility; other pages simply prime the cookie for later navigation.
  try {
    var viewedInvoices = JSON.parse(localStorage.getItem('vsViewedInvoices') || '[]');
    if (!Array.isArray(viewedInvoices)) viewedInvoices = [];
    var hasSubscriptionCookie = document.cookie.indexOf('vsHasActiveSubscription=1') !== -1;
    if (viewedInvoices.length) {
      fetch(window.vsvars.backendurl + '/api/active-subscription-invoices?InvoiceNumbers=' + encodeURIComponent(viewedInvoices.slice(-20).join(',')))
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.has_active_subscription !== hasSubscriptionCookie) {
            document.cookie = 'vsHasActiveSubscription=' + (data.has_active_subscription ? '1; max-age=3600' : '; max-age=0') + '; path=/; SameSite=Lax';
            if (isPurchasePage) window.location.reload();
          }
        })
        .catch(function () {
          // Keep the current page usable if the status API fails.
        });
    } else if (hasSubscriptionCookie) {
      document.cookie = 'vsHasActiveSubscription=; max-age=0; path=/; SameSite=Lax';
      if (isPurchasePage) window.location.reload();
    }
  } catch (e) {
    // Storage can be unavailable in private or embedded browsers.
  }

  // Purchase page
  if (isPurchasePage) {
    // Track purchase page reach as conversion for A/B tests
    vsTrackPurchasePageConversion();
  }

  // Invoice page
  if (!!window.location.href.match("invoice.cgi")) {
    try {
      var invoiceNumber = vsGetQueryParams().InvoiceNumber;
      if (invoiceNumber) {
        var viewedInvoices = JSON.parse(localStorage.getItem('vsViewedInvoices') || '[]');
        if (!Array.isArray(viewedInvoices)) viewedInvoices = [];
        viewedInvoices = viewedInvoices.filter(function (value) { return value !== invoiceNumber; });
        viewedInvoices.push(invoiceNumber);
        localStorage.setItem('vsViewedInvoices', JSON.stringify(viewedInvoices.slice(-20)));
      }
    } catch (e) {
      // Storage can be unavailable in private or embedded browsers.
    }
  }

  if(!!window.location.href.match("invoice.cgi") && timeDiff <= 7 * 86400000) {
    var transactionKey = 'vstransaction-'+window.transactionId;
    var timeDiff = ((new Date(window.currentDate)) - (new Date(window.purchaseDate)));
    var submitTransaction = function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
          'event': 'InvoiceDataReady',
          'transactionId': window.transactionId,
          'transactionAffiliation': vsSiteAffiliation,
          'transactionTotal': window.price,
          'transactionTax': 0.00,
          'transactionShipping': 0.00,
          'transactionProducts': [{
            'sku':window.SKU,
            'name':window.SKU,
            'category':'Software',
            'price':window.price,
            'quantity': 1
          }]
      });
    };
    submitTransaction()
  }

  // if(!!window.location.href.match("invoice.cgi")) {
  //   if (vsGetQueryParams().dnt != '1' && window.transactionSerial && window.transactionCustomer && window.transactionEmail && window.SKU.indexOf('Supporter') === -1) {
  //     var iframe = document.createElement('iframe');
  //     iframe.style.display = 'none';
  //     iframe.src = "vuescan://register?c=1&SerialNumber=" + window.transactionSerial.trim() + "&CustomerNumber=" + window.transactionCustomer.trim() + "&EMailAddress=" + encodeURIComponent(window.transactionEmail);
  //     console.log("iframe.src", iframe.src);
  //     document.body.appendChild(iframe);
  //   }
  // }
}

var vsSetScannerInfo = function (w32, w64, m32, m64, ppc, l32, l64, vmo, mfp) {
  window.scannerInfo = {};
  var UA = navigator.userAgent;

  var currentOrigin = vsTrimTrailingSlash(vsGetCurrentOrigin());
  var downloadOrigin = vsTrimTrailingSlash((window.vsvars && window.vsvars.baseurl) || currentOrigin);
  var https_download = downloadOrigin ? downloadOrigin + '/' : '/';
  var https = currentOrigin ? currentOrigin + '/' : (downloadOrigin ? downloadOrigin + '/' : '/');
  var osString = "";
  var downloadPageUrl = https + 'download.html?dl=1';
  var languageSubdir = vsGetLanguageSubdirectory()
  if (languageSubdir == "de") {
    downloadPageUrl = https + 'de/download.html?dl=1'
  } else if (languageSubdir == "fr") {
    downloadPageUrl = https + 'fr/download.html?dl=1'
  }

  var oc = "files/vuex6498.exe";
  var fn = null;
  var os = "Windows 11, 10, 8, 7, Vista";
  var sz = "11";

  var ve = window.vsvars.version_number;
  var up = window.vsvars.release_date;

  // Query Params
  queryParams = vsGetQueryParams();

  // If a query param is set, force it to download a certain version
  var force32 = false;
  var force64 = false;
  if (queryParams.v == "32") {
    force32 = true;
    w32 = 32;
    w64 = 32;
    m32 = 32;
    m64 = 32;
    l32 = 32;
    l64 = 32;
  } else if (queryParams.v == "64") {
    force64 = true;
    w32 = 64;
    w64 = 64;
    m32 = 64;
    m64 = 64;
    l32 = 64;
    l64 = 64;
  }

  if ((UA.indexOf("Win") != -1) &&
    (UA.indexOf("Linux") == -1)) {

    // Special handling of Windows 10/11
    if (UA.indexOf("Windows NT 10.0)") != -1) {
      if (UA.indexOf("(Windows NT 10.0)") != -1) { // Note the parens around Windows NT 10.0 - this means there is no additional architecture information - which we think means it's ARM
        // osString = "Windows 10 and 11 ARM";
        osString = "Windows";
        oc = "files/vuea6498.exe";
        os = "Windows 10/11 ARM";
        sz = "10";
      } else if ((UA.indexOf("x64") != -1) || (UA.indexOf("Win64") != -1)) {
        oc = "files/vuex6498.exe";
        os = "Windows 11, 10 x64, 8 x64, 7 x64, Vista x64";
        sz = "12";
        downloadPageUrl = downloadPageUrl + "&v=64";
      } else {
        oc = "oldfiles/vuex3298.exe";
        os = "Windows 11, 10, 8, 7, Vista";
        sz = "11";
        ve = "9.8.37";
        downloadPageUrl = downloadPageUrl + "&v=32";
      }

      // If we have access to high entropy data - use it to change the osString to differentiate between Windows 10 and Windows 11
      // if (window.vsUserAgent && window.vsUserAgent.highEntropy) {
      //   if (window.vsUserAgent.highEntropy.platform == 'Windows') {
      //     var majorPlatformVersion = parseInt(window.vsUserAgent.highEntropy.platformVersion.split('.')[0]);
      //     var isArm = window.vsUserAgent.highEntropy.architecture == 'arm';
      //     if (majorPlatformVersion >= 13) {
      //       osString = "Windows 11";
      //     } else if (majorPlatformVersion > 0) {
      //       osString = "Window 10"
      //     }
      //     if (isArm) {
      //       osString += " ARM"
      //     }
      //   }
      // }
    } else if ((UA.indexOf("ARM") != -1) &&
      (UA.indexOf("Phone") == -1) &&
      (UA.indexOf("Lumia") == -1)) {
      if (UA.indexOf("NT 6.") != -1) {
        osString = "Windows RT";
        oc = "oldfiles/vuea3298.exe";
        os = "Windows RT 8.0, 8.1";
        sz = "10";
        ve = "9.8.37";
      } else {
        osString = "Windows ARM";
        oc = "files/vuea6498.exe";
        os = "Windows 10/11 ARM";
        sz = "10";
      }
    } else if ((UA.indexOf("WOW64") != -1) ||
      (UA.indexOf("x64") != -1) ||
      (UA.indexOf("Win64") != -1) ||
      force64) {
      if (w64 == 64 || force64) {
        oc = "files/vuex6498.exe";
        os = "Windows 11, 10 x64, 8 x64, 7 x64, Vista x64";
        sz = "12";
      } else if ((w32 == 32) || (w64 == 32)) {
        oc = "oldfiles/vuex3298.exe";
        os = "Windows 11, 10, 8, 7, Vista";
        sz = "11";
        ve = "9.8.37";
        downloadPageUrl = downloadPageUrl + "&v=32";
      } else {
        return;
      }
    } else {
      if (w32 == 32 || force32) {
        oc = "oldfiles/vuex3298.exe";
        os = "Windows 11, 10, 8, 7, Vista";
        sz = "11";
        ve = "9.8.37";
        downloadPageUrl = downloadPageUrl + "&v=32";
      } else {
        return;
      }
    }

    if (osString.length == 0) {
      // if (UA.match("NT 6.0")) {
      //   osString = "Windows Vista";
      // } else if (UA.match("NT 6.1")) {
      //   osString = "Windows 7";
      // } else if (UA.match("NT 6.2")) {
      //   osString = "Windows 8";
      // } else if (UA.match("NT 6.3")) {
      //   osString = "Windows 8.1";
      // } else if (UA.match("NT 6.4")) {
      //   osString = "Windows 10 and 11";
      // } else if (UA.match("NT 10.0")) {
      //   osString = "Windows 10 and 11";
      // } else {
      //   osString = "Windows";
      // }
      osString = "Windows";
    }

    fn = https_download + oc;
  } else if (UA.match(/(iPhone|iPad|iPod)/) || UA.match(/(Android)/)) {
    osString = "Mobile"
  } else if ((UA.indexOf("Linux") != -1) ||
    (UA.indexOf("X11") != -1)) {

    if (UA.indexOf("Fedora") != -1) {
      osExt = "rpm";
    } else if (UA.indexOf("Ubuntu") != -1) {
      osExt = "deb";
    } else {
      osExt = "tgz";
    }

    osString = "Linux";

    if (UA.indexOf("aarch64") != -1) {
      osArch = "a64";
      osBuild = "64-bit Ubuntu 18.04";
      osString = "64-bit Raspberry Pi";
    } else if (UA.indexOf("armv7l") != -1) {
      osArch = "a32";
      osBuild = "32-bit Ubuntu 18.04";
      osString = "32-bit Raspberry Pi";
      downloadPageUrl = downloadPageUrl + "&v=32";
    } else if (UA.indexOf("x86_64") != -1) {
      if (l64 == 64) {
        osArch = "x64";
        osBuild = "64-bit Ubuntu 18.04";
      } else {
        osArch = "x32";
        osBuild = "32-bit Ubuntu 18.04";
        downloadPageUrl = downloadPageUrl + "&v=32";
      }
      osString = "64-bit Linux";
    } else {
      osArch = "x32";
      osBuild = "32-bit Ubuntu 18.04";
      downloadPageUrl = downloadPageUrl + "&v=32";
      osString = "32-bit Linux";
    }

    oc = "files/vue" + osArch + "98." + osExt;
    os = "Built with " + osBuild;
    sz = "9";

    fn = https_download + oc;
  } else {
    osString = "macOS";
    // We need to use regex here to do the matching since firefox uses decimals to separate version numbers while safari
    // and chrome use underscores
    // Matches either firefox style 10.4 or chrome and safari 10_4
    if ((UA.indexOf("PPC Mac") != -1) ||
      (ppc && !m32 && !m64)) {
      if (UA.match('X 10(_|.)[4-6]')) {
        oc = "oldfiles/vuex3290.dmg";
        sz = "9";
        ve = "9.0.96";
        up = "June 3, 2012";

        os = "Last version for PowerPC";
      } else {
        return;
      }
    } else if (UA.match('X 10(_|.)4')) {
      oc = "oldfiles/vuex3290.dmg";
      sz = "9";
      ve = "9.0.96";
      up = "June 3, 2012";

      os = "Last version for Max OS X 10.4";
    } else if (UA.match('X 10(_|.)5')) {
      oc = "files/vuex329617.dmg";
      sz = "8";
      ve = "9.6.17";
      up = "September 24, 2018";

      os = "Last version for Max OS X 10.5";
    } else if (UA.match('X 10(_|.)6')) {
      oc = "files/vuex329617.dmg";
      sz = "8";
      ve = "9.6.17";
      up = "September 24, 2018";

      os = "Last version for Max OS X 10.6";
    } else if (UA.match('X 10(_|.)7') ||
               UA.match('X 10(_|.)8') ||
               UA.match('X 10(_|.)9')) {
      // oc = "files/vuex329617.dmg";
      sz = "8";
      ve = "9.7.31";
      up = "August 20, 2020";
      os = "Last version for Max OS X 10.7-10.9";
      fn = "http://files.hamrick.com/version-archive/9.7.31/vuex6497.dmg";
      downloadPageUrl = fn;
    } else {
      if (UA.match('X 10(_|.)7')) {
        if (m32 == 32)
          m64 = 0;
      }

      if (UA.match('X 10(_|.)1[5-6]') ||
          UA.match('X 1[1-3](_|.)')) {
        oc = "files/vuea6498.dmg";
        os = "macOS 10.12-macOS 26 Universal";
        sz = "15";
      } else if (m64 == 64) {
        oc = "files/vuex6498.dmg";
        os = "macOS 10.12-macOS 26";
        sz = "15";
      } else if ((m32 == 32) || (m64 == 32)) {
        oc = "oldfiles/vuex3298.dmg";
        os = "macOS 10.12-macOS 26";
        sz = "15";
        ve = "9.8.37";
        downloadPageUrl = downloadPageUrl + "&v=32";
      } else {
        return;
      }
    }

    // if (UA.match('X 10(_|.)4')) {
    //   osString = "Mac OS X Tiger";
    // } else if (UA.match('X 10(_|.)5')) {
    //   osString = "Mac OS X Leopard";
    // } else if (UA.match('X 10(_|.)6')) {
    //   osString = "Mac OS X Snow Leopard";
    // } else if (UA.match('X 10(_|.)7')) {
    //   osString = "Mac OS X Lion";
    // } else if (UA.match('X 10(_|.)8')) {
    //   osString = "Mac OS X Mountain Lion";
    // } else if (UA.match('X 10(_|.)9')) {
    //   osString = "Mac OS X Mavericks";
    // } else if (UA.match('X 10(_|.)10')) {
    //   osString = "Mac OS X Yosemite";
    // } else if (UA.match('X 10(_|.)11')) {
    //   osString = "Mac OS X El Capitan";
    // } else if (UA.match('X 10(_|.)12')) {
    //   osString = "macOS Sierra";
    // } else if (UA.match('X 10(_|.)13')) {
    //   osString = "macOS High Sierra";
    // } else if (UA.match('X 10(_|.)14')) {
    //   osString = "macOS Mojave";
    // } else if (UA.match('X 10(_|.)15(_|.)6')) {
    //   osString = "macOS Big Sur";
    // } else if (UA.match('X 10(_|.)15(_|.)7')) {
    //   osString = "macOS Ventura";
    // } else if (UA.match('X 10(_|.)15(_|.)8')) {
    //   osString = "macOS Ventura";
    // } else if (UA.match('X 10(_|.)16')) {
    //   osString = "macOS Big Sur";
    // } else if (UA.match('X 11(_|.)0')) {
    //   osString = "macOS Big Sur";
    // } else if (UA.match('X 10(_|.)15')) {
    //   osString = "macOS Catalina";
    // } else if (UA.match('X 12(_|.)0')) {
    //   osString = "macOS Monterey";
    // } else if (UA.match('X 13(_|.)0')) {
    //   osString = "macOS Ventura";
    // } else {
    //   osString = "macOS";
    // }
    osString = "macOS";

    if (queryParams.a == "a64")
      oc = "files/vuea6498.dmg";
    else if (queryParams.a == "x64")
      oc = "files/vuex6498.dmg";
    // else if (queryParams.a == "x32") {
    //   oc = "oldfiles/vuex3298.dmg";
    //   ve = "9.8.37";
    // }

    if (!fn) {
      fn = https_download + oc;
    }
  }

  window.scannerInfo = {
    osString: osString,
    downloadPageUrl: downloadPageUrl,
    os: os,
    sz: sz,
    oc: oc,
    ve: ve,
    up: up,
    fn: fn,
    mfp: mfp
  }
  return window.scannerInfo;
}

var vsGetStatObj = function () {
  var queryParams = vsGetQueryParams();
  var statObj = {
    "CanonicalURL": vsGetCanonicalUrl(),
    "Href": window.location.href,
    "Search": window.location.search,
    "Protocol": window.location.protocol,
    "Path": location.pathname,
    "UserAgent": navigator.userAgent,
    "Referrer": document.referrer,
    "LeadID": localStorage.getItem("vsLeadID"),
    "vsABID": vsGetCookie('vsABID'),
    "utm_campaign": queryParams['utm_campaign'],
    "utm_source": queryParams['utm_source'],
    "utm_medium": queryParams['utm_medium']
  };
  var scannerPage = vsGetCookie("vsScannerPage").toLowerCase();
  scannerComps = scannerPage.split(";");
  if (scannerComps.length == 3) {
    statObj.scannerVendor = scannerComps[0];
    statObj.scannerName = scannerComps[1];
    statObj.scannerCapabilities = scannerComps[2];
  }
  // window.vsPageInfo is only set on reltosca-generated scanner model pages,
  // not on Jekyll-generated vendor pages.
  if (window.vsPageInfo && window.vsPageInfo.isScannerPage) {
    statObj.isScannerPage = 1;
  }

  // Add feedback data to stat obj either from the query string (if they're on feedback.html) or localStorage
  if (queryParams.Version) {
    for (key in queryParams) {
      statObj[key] = queryParams[key]
    }
  } else if (localStorage.getItem("FeedbackData")) {
    feedbackData = JSON.parse(localStorage.getItem("FeedbackData"));
    for (key in feedbackData) {
      statObj[key] = feedbackData[key]
    }
  }

  // Add transaction data if relevant
  if (window.transactionId) {
    statObj.transactionId = window.transactionId;
    statObj.price = window.price;
    statObj.SKU = window.SKU;
    statObj.purchaseDate = window.purchaseDate;
    statObj.currentDate = window.currentDate;
  }

  // Add high entropy data if we have it
  if (window.vsUserAgent && window.vsUserAgent.highEntropy) {
    statObj.heArchitecture = window.vsUserAgent.highEntropy.architecture;
    statObj.heBitness = window.vsUserAgent.highEntropy.bitness;
    statObj.heMobile = window.vsUserAgent.highEntropy.mobile;
    statObj.hePlatform = window.vsUserAgent.highEntropy.platform;
    statObj.hePlatformVersion = window.vsUserAgent.highEntropy.platformVersion;
  }

  return statObj;
}
window.vsGetStatObj = vsGetStatObj

// Feature Flags System
window.vsFeatureFlags = {};
window.vsFeatureFlagsLoaded = false;

window.vsLoadFeatureFlags = function() {
  var statObj = vsGetStatObj();
  var url = window.vsvars.backendurl + "/api/feature-flags?" + vsToQueryString(statObj);

  fetch(url)
    .then(function(response) { return response.json(); })
    .then(function(data) {
      // Set cookie if we got a new AB ID
      if (data.vs_ab_id && data.vs_ab_id !== vsGetCookie('vsABID')) {
        vsSetCookie('vsABID', data.vs_ab_id);
      }

      // Apply feature flags
      window.vsFeatureFlags = data.flags || {};
      window.vsCountryCode = data.country_code;
      window.vsFeatureFlagsLoaded = true;

      // Cache email download variation in localStorage for race condition fallback
      if (window.vsFeatureFlags.emailDownloadVariation) {
        localStorage.setItem('vsEmailDownloadVariation', window.vsFeatureFlags.emailDownloadVariation);
      } else {
        localStorage.removeItem('vsEmailDownloadVariation');
      }

    })
    .catch(function(error) {
      console.error('Feature flags failed:', error);
      window.vsFeatureFlags = {};
      window.vsFeatureFlagsLoaded = true;
    });
};

var vsLoadOnce = function () {
  vsLoadOnce = function () {}; // Make sure it can only be executed once

  vsGetUserAgent(function (ua) {
    vsUpdateDOMElements();

    // Load feature flags first
    vsLoadFeatureFlags();

    statObj = vsGetStatObj();
    if (!vsIsLocal()) {
      vsJSONP("https://stats.hamrick.com/v1/stat", "vsStatCallback", statObj);
    }
  });
};

window.vsStatCallback = function (data) {
  window.vsCountryCode = data.country_code;
  window.vsCountryTier = data.country_tier;
}

// Generic function to track page conversions for A/B tests
window.vsTrackPageConversion = function(eventName, storageKeyPrefix) {
  var vsABID = vsGetCookie('vsABID');
  if (vsABID) {
    var conversionKey = storageKeyPrefix + '_' + vsABID;
    if (!localStorage.getItem(conversionKey)) {
      localStorage.setItem(conversionKey, new Date().toISOString());
      
      // Send stats tracking
      if (!vsIsLocal()) {
        var trackingObj = vsGetStatObj();
        trackingObj.ABTestEvent = eventName;
        vsJSONP("https://stats.hamrick.com/v1/stat", null, trackingObj);
      }
      
      // Track in A/B test system
      fetch(window.vsvars.backendurl + "/api/feature-flags", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          vsABID: vsABID,
          ABTestEvent: eventName
        })
      }).catch(function(error) {
        console.error('Error tracking ' + eventName + ':', error);
      });
    }
  }
}

// Track download page conversion
window.vsTrackDownloadConversion = function() {
  vsTrackPageConversion('download_page_reached', 'vsDownloadConversion');
}

// Track purchase page conversion
window.vsTrackPurchasePageConversion = function() {
  vsTrackPageConversion('purchase_page_reached', 'vsPurchasePageConversion');
}

if (vsIsLocal()) {
  document.body.addEventListener('htmx:configRequest', function(event) {
    event.detail.headers = ''
    event.detail.headers['Content-Type'] = "application/x-www-form-urlencoded; charset=UTF-8"
  });
}

// Update DOM elements whenever HTMX swaps in new content
document.addEventListener("htmx:afterSwap", function (type, listener, options) {
  vsUpdateDOMElements();
});

// Add global HTMX event handler for a callback after a new page is loaded
window.vsLastUrl = location.href;
document.body.addEventListener('htmx:afterSwap', function(evt) {
  var currentUrl = location.href;
  if (currentUrl !== window.vsLastUrl) {
    statObj = vsGetStatObj();
    if (!vsIsLocal()) {
      vsJSONP("https://stats.hamrick.com/v1/stat", "vsStatCallback", statObj);
    } else {
      console.log('vsStatCallback', statObj);
    }
    window.vsLastUrl = currentUrl;
  }
});


window.vsCacheBust='12';

// Provide a blank callback for jsonp responses
window.callback = function () { };

vsReady(vsLoadOnce);

window.vsmenujsloaded = true;
